// externals
import type { Reducer } from 'redux';

// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { AvoState } from '@makemydeal/dr-dash-types';

// consts/enums
import { MARK_AVO_FRESH, MARK_AVO_STALE } from '../actionTypes/avoActionTypes';

export type AvoReducer = Reducer<AvoState>;

const initialState: AvoState = {
    isStale: true,
    lastFetchedAt: null
};

export const reducer: AvoReducer = (state = initialState, action: AnyFSA): AvoState => {
    switch (action.type) {
        case MARK_AVO_STALE:
            return { ...state, isStale: true };
        case MARK_AVO_FRESH:
            return { isStale: false, lastFetchedAt: Date.now() };
        default:
            return state;
    }
};
